"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _TokenResultItem = _interopRequireDefault(require("./TokenResultItem"));

var _default = function _default() {
  var emptyOption = {
    text: _I18n.default.text('draftPlugins.tokenPlugin.resultsZeroState.text'),
    value: 'empty'
  };
  return _react.default.createElement(_TokenResultItem.default, {
    key: emptyOption.value,
    highlighted: false,
    disabled: true,
    option: emptyOption
  });
};

exports.default = _default;
module.exports = exports.default;